import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../components/util/Loading';
import { supabase } from '../supabaseClient';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);        // 구글 UUID
  const [profile, setProfile] = useState(null);  // 코크플레이 회원 프로필
  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();
  
  const logIn = (user) => {
    setUser(user);

  }

  const logOut = () => {
    setUser(null);
    setProfile(null);
    supabase.auth.signOut();
    navigate('/home')

  }

  useEffect(() => {
    // 1) 초기에 세션이 남아 있는지 확인 
    if (!isLoading) return;
    
    supabase.auth.getSession().then(({ data: { session } }) => {
      setUser(session?.user ?? null);
      setIsLoading(false);
    });
  }, [isLoading]);

  // 3) user가 바뀔 때마다 내 테이블에서 프로필 조회
  useEffect(() => {
    if (!user) {
      setProfile(null);
      return;
    }

    (async () => {
      console.log('tb_member 조회');
      const { data, error } = await supabase
        .from('tb_member')
        .select('member_seq, name')
        .eq('google_uuid', user.id)
        .single();
      if (error && error.code !== 'PGRST116') {
        console.error('프로필 조회 실패', error);
        return;
      }
      setProfile(data);
    })();
  }, [user]);

  if (isLoading) {
    return (
      <div className="container">
        <Loading message="로그인 중입니다..." />
      </div>
    );
  }

  return (
    <AuthContext.Provider value={{ user, profile, logIn, logOut}}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);